module.exports = __webpack_public_path__ + "45544768b1686adc4f9c5dbb698cec61.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Bottle/label.png
// module id = 396
// module chunks = 0